import type { SvgProps } from "replo-utils/react/components";

import React from "react";

import { Svg } from "replo-utils/react/components";

interface SvgProductImageColorBlobProps extends SvgProps {
  blurAmount?: number;
}

function SvgProductImageColorBlob({
  blurAmount,
  ...props
}: SvgProductImageColorBlobProps) {
  const filterId = blurAmount
    ? `blur-filter-${Math.random().toString(36).slice(2, 11)}`
    : undefined;
  return (
    <Svg
      width="400"
      height="283"
      viewBox="0 0 400 283"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        opacity="0.9"
        filter={
          filterId
            ? `url(#filter0_fn_11716_23916) url(#${filterId})`
            : "url(#filter0_fn_11716_23916)"
        }
      >
        <mask
          id="mask0_11716_23916"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="-419"
          y="31"
          width="944"
          height="528"
        >
          <rect
            x="-371.897"
            y="31.2383"
            width="901.052"
            height="434.195"
            transform="rotate(6.10511 -371.897 31.2383)"
            fill="#C4C4C4"
          />
        </mask>
        <g mask="url(#mask0_11716_23916)">
          <rect
            x="-412.941"
            y="26.6152"
            width="983.649"
            height="458.769"
            transform="rotate(6.10511 -412.941 26.6152)"
            fill="black"
          />
          <g filter="url(#filter1_f_11716_23916)">
            <path
              d="M-236.515 201.427L187.937 84.7318L373.079 104.534L595.086 171.505L-224.809 325.408L-236.515 201.427Z"
              fill="url(#paint0_linear_11716_23916)"
            />
          </g>
          <g filter="url(#filter2_f_11716_23916)">
            <ellipse
              cx="199.454"
              cy="53.7954"
              rx="199.454"
              ry="53.7954"
              transform="matrix(0.975577 -0.219657 0.314349 0.949307 -73.291 229.129)"
              fill="#FEBC2E"
            />
          </g>
          <g filter="url(#filter3_f_11716_23916)">
            <path
              d="M122.429 230.73C314.384 179.964 391.185 184.783 565.084 230.544L613.677 327.411L-260.641 441.847C-276.008 437.94 -224.737 386.272 -92.3185 313.859C-67.3579 300.21 -69.5269 281.497 122.429 230.73Z"
              fill="url(#paint1_linear_11716_23916)"
            />
          </g>
          <g opacity="0.7" filter="url(#filter4_f_11716_23916)">
            <path
              d="M255.201 198.746C435.365 162.151 390.526 173.506 551.015 215.372L595.979 303.544L-204.096 405.535C-218.278 401.96 -230.12 357.056 -174.154 300.675C-104.196 230.198 45.4756 241.346 255.201 198.746Z"
              fill="#B7FEAE"
              fillOpacity="0.5"
            />
          </g>
          <g filter="url(#filter5_f_11716_23916)">
            <path
              d="M283.164 262.867C432.948 250.216 428.347 223.244 559.273 255.442L571.519 318.158L-78.6196 386.784C-90.1883 384.03 -100.194 350.816 -55.1214 309.696C1.21907 258.296 170.291 272.4 283.164 262.867Z"
              fill="#EF196E"
            />
          </g>
          <g opacity="0.4" filter="url(#filter6_f_11716_23916)">
            <ellipse
              cx="199.454"
              cy="78.0972"
              rx="199.454"
              ry="78.0972"
              transform="matrix(0.975577 -0.219657 0.314349 0.949307 -128.229 329.117)"
              fill="#FFEB80"
            />
          </g>
          <g filter="url(#filter7_f_11716_23916)">
            <ellipse
              cx="199.454"
              cy="53.7954"
              rx="199.454"
              ry="53.7954"
              transform="matrix(0.975577 -0.219657 0.314349 0.949307 216.176 303.609)"
              fill="#B7FEAE"
            />
          </g>
          <g filter="url(#filter8_f_11716_23916)">
            <path
              d="M345.371 202.374L658.336 116.685L568.631 250.56L345.371 202.374Z"
              fill="#274AE2"
            />
          </g>
          <g filter="url(#filter9_f_11716_23916)">
            <g opacity="0.4" filter="url(#filter10_f_11716_23916)">
              <path
                d="M46.0343 373.846L538.434 255.533L765.721 255.338L1045.91 286.536L82.1151 463.075L46.0343 373.846Z"
                fill="url(#paint2_linear_11716_23916)"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        {/* Add blur filter if blurAmount is specified */}
        {filterId && (
          <filter
            id={filterId}
            x="-50%"
            y="-50%"
            width="200%"
            height="200%"
            filterUnits="objectBoundingBox"
          >
            <feGaussianBlur stdDeviation={blurAmount} in="SourceGraphic" />
          </filter>
        )}
        <filter
          id="filter0_fn_11716_23916"
          x="-448.374"
          y="0.939415"
          width="1002.72"
          height="588.16"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="15.1494"
            result="effect1_foregroundBlur_11716_23916"
          />
          <feTurbulence
            type="fractalNoise"
            baseFrequency="7.3633885383605957 7.3633885383605957"
            stitchTiles="stitch"
            numOctaves="3"
            result="noise"
            seed="7978"
          />
          <feColorMatrix
            in="noise"
            type="luminanceToAlpha"
            result="alphaNoise"
          />
          <feComponentTransfer in="alphaNoise" result="coloredNoise1">
            <feFuncA
              type="discrete"
              tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
            />
          </feComponentTransfer>
          <feComposite
            operator="in"
            in2="effect1_foregroundBlur_11716_23916"
            in="coloredNoise1"
            result="noise1Clipped"
          />
          <feFlood floodColor="rgba(0, 0, 0, 0.25)" result="color1Flood" />
          <feComposite
            operator="in"
            in2="noise1Clipped"
            in="color1Flood"
            result="color1"
          />
          <feMerge result="effect2_noise_11716_23916">
            <feMergeNode in="effect1_foregroundBlur_11716_23916" />
            <feMergeNode in="color1" />
          </feMerge>
        </filter>
        <filter
          id="filter1_f_11716_23916"
          x="-236.862"
          y="84.3862"
          width="832.294"
          height="241.368"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.173101"
            result="effect1_foregroundBlur_11716_23916"
          />
        </filter>
        <filter
          id="filter2_f_11716_23916"
          x="-79.9466"
          y="146.277"
          width="436.298"
          height="180.218"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="11.4106"
            result="effect1_foregroundBlur_11716_23916"
          />
        </filter>
        <filter
          id="filter3_f_11716_23916"
          x="-266.258"
          y="191.437"
          width="882.916"
          height="253.392"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.49063"
            result="effect1_foregroundBlur_11716_23916"
          />
        </filter>
        <filter
          id="filter4_f_11716_23916"
          x="-217.327"
          y="175.274"
          width="814.745"
          height="231.701"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.719608"
            result="effect1_foregroundBlur_11716_23916"
          />
        </filter>
        <filter
          id="filter5_f_11716_23916"
          x="-188.425"
          y="140.227"
          width="859.943"
          height="346.557"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="50"
            result="effect1_foregroundBlur_11716_23916"
          />
        </filter>
        <filter
          id="filter6_f_11716_23916"
          x="-121.579"
          y="256.977"
          width="424.967"
          height="204.932"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="8.16857"
            result="effect1_foregroundBlur_11716_23916"
          />
        </filter>
        <filter
          id="filter7_f_11716_23916"
          x="222.403"
          y="233.64"
          width="410.532"
          height="154.452"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="4.96901"
            result="effect1_foregroundBlur_11716_23916"
          />
        </filter>
        <filter
          id="filter8_f_11716_23916"
          x="322.441"
          y="93.7554"
          width="358.825"
          height="179.735"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="11.4651"
            result="effect1_foregroundBlur_11716_23916"
          />
        </filter>
        <filter
          id="filter9_f_11716_23916"
          x="44.5677"
          y="253.871"
          width="1002.81"
          height="210.671"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.733233"
            result="effect1_foregroundBlur_11716_23916"
          />
        </filter>
        <filter
          id="filter10_f_11716_23916"
          x="45.61"
          y="254.914"
          width="1000.72"
          height="208.587"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.212092"
            result="effect1_foregroundBlur_11716_23916"
          />
        </filter>
        <linearGradient
          id="paint0_linear_11716_23916"
          x1="190.141"
          y1="84.9675"
          x2="-104.449"
          y2="345.974"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7D54" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11716_23916"
          x1="389.8"
          y1="233.865"
          x2="-13.5521"
          y2="368.303"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B7FEAE" />
          <stop offset="0.65537" stopColor="#EF196E" />
          <stop offset="1" stopColor="#274AE2" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11716_23916"
          x1="541.14"
          y1="255.531"
          x2="385.989"
          y2="550.063"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A4CF0" />
          <stop offset="1" stopColor="#F5FAD9" stopOpacity="0" />
        </linearGradient>
      </defs>
    </Svg>
  );
}

export default SvgProductImageColorBlob;
